import { FeatureMouseInteraction } from '@openlayers/interaction/FeatureMouseInteraction';
import { MapOverlays } from '@openlayers/ol-overlays';
import Feature from 'ol/Feature';
import OlMap from 'ol/Map';
import { DateUtils } from '@shared/utils/DateUtils';


export class MassGridCellMouseInteraction extends FeatureMouseInteraction {
    private calcByStation = {};
    private rowsCount = 0;

    constructor(map: OlMap, calculationData: Mass.AreaCalculation) {
        super(map);

        if (calculationData && calculationData.rows) {
            calculationData.rows.forEach(row => {
                // @ts-ignore
                row.cut = parseFloat(row.cut).toFixed(2);
                // @ts-ignore
                row.volumeCut = parseFloat(row.volumeCut).toFixed(2);
                // @ts-ignore
                row.sumCut = parseFloat(row.sumCut).toFixed(2);

                // @ts-ignore
                row.fill = parseFloat(row.fill).toFixed(2);
                // @ts-ignore
                row.volumeFill = parseFloat(row.volumeFill).toFixed(2);
                // @ts-ignore
                row.sumFill = parseFloat(row.sumFill).toFixed(2);

                // @ts-ignore
                row.limit = parseFloat(row.limit).toFixed(2);
                // @ts-ignore
                row.volumeLimit = parseFloat(row.volumeLimit).toFixed(2);
                // @ts-ignore
                row.sumLimit = parseFloat(row.sumLimit).toFixed(2);
                this.calcByStation[row.station] = row;
            });

            this.rowsCount = Object.keys(this.calcByStation).length;
        }
    }

    onClick = (feature: Feature, e?, n?): void => {
        if (!this.rowsCount) return;

        const data = feature.get('data');
        const station = `Y:${data.y} X:${data.x}`;
        const row = this.calcByStation[station];
        console.log('row', row);
        console.log('feature', data);
    };

    onMouseOver = (feature: Feature, e?, n?): void => {
        if (!this.rowsCount) return;

        const data = feature.get('data');
        const station = `Y:${data.y} X:${data.x}`;
        const row = this.calcByStation[station];

        let html = '<div class="card">';
        html += getRowHtml(row);
        html += '<div style="background: #e2e2e2; text-align: center">' + station + '</div>';
        html += '</div>';

        MapOverlays.showTooltip(this.map, html, e, n, feature);
    };
}


function getRowHtml(row: Mass.Row): string {
    let html = '<div class="padded">';
    // @ts-ignore
    html += getRowPropHtml('Cut', row.cut);
    // @ts-ignore
    html += getRowPropHtml('Volume cut', row.volumeCut);
    // @ts-ignore
    html += getRowPropHtml('Sum cut', row.sumCut);
    html += '<hr>';
    // @ts-ignore
    html += getRowPropHtml('Fill', row.fill);
    // @ts-ignore
    html += getRowPropHtml('Volume fill', row.volumeFill);
    // @ts-ignore
    html += getRowPropHtml('Sum fill', row.sumFill);
    html += '<hr>';
    // @ts-ignore
    html += getRowPropHtml('Limit', row.limit);
    // @ts-ignore
    html += getRowPropHtml('Volume limit', row.volumeLimit);
    // @ts-ignore
    html += getRowPropHtml('Sum limit', row.sumLimit);
    html += '<hr>';
    html += `<div style="opacity: ${!row.completedDateCut ? 0.3 : 1}">Cut completed: ${row.completedDateCut ? DateUtils.formatDate(row.completedDateCut) : ''}</div>`;
    html += `<div style="opacity: ${!row.completedDateFill ? 0.3 : 1}">Fill completed: ${row.completedDateFill ? DateUtils.formatDate(row.completedDateFill) : ''}</div>`;
    html += '</div>';

    return html;
}

function getRowPropHtml(name, value: string): string {
    return `<div style="opacity: ${parseFloat(value) === 0 ? 0.3 : 1}">${name}: ${value}</div>`;
}
